/* [ASB sets] Signature Fragrance Mix scent picker (snippets/asb-signature-mix.liquid)
   Custom file — not part of Dawn 15.4.0.
   Built by: Codex/Claude (2026-09, as a pasted Custom Liquid block); moved here with a no-APO mode by Claude (2026-11-01).
   What it does: scent search + blend list (2–5 scents) written into the blend field; Add to cart disabled until the
   blend is valid. Native mode (product has a "Size" option): Dawn form properties "Your custom fragrance mix" and
   "How would you like to start?". APO mode: APO's own fields, as before. See the snippet for details.
   Used by: snippets/asb-signature-mix.liquid. */
(function(){
  'use strict';
  if(window.__ASB_MIX__) return; window.__ASB_MIX__ = 1;

  /* ========================= CONFIG ========================= */
  var CFG = {
    collection:  'all',
    productType: 'Inspired Scent',
    minScents:   2,
    defaultMax:  5,

    // Bottle size -> scents allowed. FIRST MATCH WINS, so the 10 ml rule must
    // sit before the 100 ml one. Set max:null (plus a msg) to bar a size entirely.
    capacityRules: [
      { test:/travel|(^|[^0-9])10\s*ml/, max:5 },   // 10 ml - Travel Size
      { test:/200\s*ml/,                 max:7 },
      { test:/100\s*ml/,                 max:5 },
      { test:/(^|[^0-9])50\s*ml/,        max:4 },
      { test:/oil/,                      max:5 }    // Body Oil 4 oz (native Size value)
    ],

    mixLabel:      'custom fragrance mix',   // label text of the APO textarea
    capacityLabel: 'capacity',               // label text of the APO capacity option

    // The APO mix field sits ABOVE the capacity option, so at that point in the
    // page we cannot know how many scents fit. Rather than reordering options in
    // the APO admin, the picker physically moves itself to sit just AFTER the
    // option named here — so the customer picks a bottle size first, and the
    // limit is always known. Set to null to leave it where the textarea is.
    placeAfterLabel: 'capacity',
    separator:     ' + ',
    cacheMins:     60
  };
  /* ========================================================== */

  var index=[], chosen=[], results=[], MAX=CFG.defaultMax, CAPLABEL='', BLOCK=null;
  var apoInput=null, apoWrap=null;
  // Native mode (no APO): the product has a "Size" option; snippets/asb-signature-mix.liquid renders the field.
  var NATIVE=!!document.querySelector('[data-asb-sig-native]');
  var START={ '10 ml':'Sample first · 10 ml', '100 ml':'Full bottle · 100 ml' };
  function nativeSize(){
    var f=document.querySelector('[data-asb-sig-native]');
    var c=f && document.querySelector('product-info variant-selects input[type="radio"][name^="Size-'+f.dataset.option+'"]:checked');
    return c ? c.value.trim() : '';
  }
  // "How would you like to start?" follows the size: sent for 10 ml / 100 ml, not for Body Oil.
  function syncStart(){
    var s=document.querySelector('[data-asb-sig-start]'); if(!s) return;
    var v=START[nativeSize().toLowerCase()]||'';
    s.value=v; s.disabled=!v;
  }

  var norm=function(s){return normMap(s).n;};
  // Returns the normalised string plus map[i] = index in the ORIGINAL string
  // of normalised character i, so highlights can slice the original safely.
  function normMap(str){
    var src=String(str||''), out='', map=[], lastSpace=true;
    for(var i=0;i<src.length;i++){
      var ch=src[i], c=ch.toLowerCase();
      // Fold accents so "ideal" finds "L'HOMME IDÉAL" and "millesime" finds
      // "MILLÉSIME IMPERIAL". One source char still yields one output char,
      // so the normalised->original index map stays exact.
      if(c.normalize){ var f=c.normalize("NFD").replace(/[̀-ͯ]/g,""); if(f.length===1) c=f; }
      if(c==="'"||c==='\u2019') continue;                 // dropped, not replaced
      if(!/[a-z0-9]/.test(c)) c=' ';                       // punctuation -> space
      if(c===' '){ if(lastSpace) continue; lastSpace=true; }
      else lastSpace=false;
      out+=c; map.push(i);
    }
    if(out.slice(-1)===' '){ out=out.slice(0,-1); map.pop(); }
    return {n:out, map:map};
  }
  var esc=function(s){return String(s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});};
  var rxEsc=function(s){return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');};

  /* ---- scent list ---- */
  function cached(){try{var o=JSON.parse(sessionStorage.getItem('asb_scents')||'null');
    return (o && Date.now()-o.t < CFG.cacheMins*6e4) ? o.v : null;}catch(e){return null;}}
  function loadScents(){
    if(window.__ASB_SCENTS__ && window.__ASB_SCENTS__.length) return Promise.resolve(window.__ASB_SCENTS__);
    var hit=cached(); if(hit && hit.length) return Promise.resolve(hit);
    var all=[];
    function page(p){
      if(p>6) return Promise.resolve(all);
      return fetch('/collections/'+CFG.collection+'/products.json?limit=250&page='+p,
                   {headers:{Accept:'application/json'}})
        .then(function(r){return r.ok?r.json():{products:[]};})
        .then(function(d){var g=(d&&d.products)||[]; all=all.concat(g);
          return g.length===250?page(p+1):all;});
    }
    return page(1).then(function(l){
      var n=l.filter(function(p){return !CFG.productType || norm(p.product_type)===norm(CFG.productType);})
             .map(function(p){return p.title.trim();})
             .filter(function(t,i,a){return t && a.indexOf(t)===i;})
             .sort(function(a,b){return a.localeCompare(b);});
      try{sessionStorage.setItem('asb_scents',JSON.stringify({t:Date.now(),v:n}));}catch(e){}
      return n;
    }).catch(function(){return [];});
  }

  /* ---- search ---- */
  function search(q){
    var nq=norm(q); if(!nq) return index.slice(0,60);
    var toks=nq.split(' '), out=[], rx=new RegExp('\\b'+rxEsc(nq));
    for(var i=0;i<index.length;i++){var it=index[i],s=-1;
      if(it.n.indexOf(nq)===0)s=0; else if(rx.test(it.n))s=1;
      else if(it.n.indexOf(nq)>-1)s=2;
      else if(toks.length>1&&toks.every(function(t){return it.n.indexOf(t)>-1;}))s=3;
      if(s>=0)out.push({it:it,s:s});}
    out.sort(function(a,b){return a.s-b.s||a.it.name.length-b.it.name.length||a.it.name.localeCompare(b.it.name);});
    return out.slice(0,80).map(function(o){return o.it;});
  }
  function hl(name,q){
    var nq=norm(q); if(!nq) return esc(name);
    var nm=normMap(name), i=nm.n.indexOf(nq); if(i<0) return esc(name);
    // translate normalised range -> original range via the map
    var a=nm.map[i], b=nm.map[i+nq.length-1];
    if(a==null||b==null) return esc(name);
    b+=1;
    return esc(name.slice(0,a))+'<b>'+esc(name.slice(a,b))+'</b>'+esc(name.slice(b));
  }

  /* ---- find APO options by their visible label ---- */
  function findOption(frag){
    var f=norm(frag), wraps=document.querySelectorAll('.mw-option');
    for(var i=0;i<wraps.length;i++){
      var lab=wraps[i].querySelector('.mw-label');
      if(lab && norm(lab.textContent).indexOf(f)>-1) return wraps[i];
    }
    return null;
  }
  // APO radio values are internal ids — the human text lives in the wrapping label
  function ctrlText(c){
    var l=c.closest('label')||document.querySelector('label[for="'+c.id+'"]');
    return l?l.innerText.trim():'';
  }
  function maxPossible(){
    var m=0; CFG.capacityRules.forEach(function(r){ if(r.max>m) m=r.max; }); return m||CFG.defaultMax;
  }
  function minPossible(){
    var m=null; CFG.capacityRules.forEach(function(r){
      if(typeof r.max==='number' && (m===null||r.max<m)) m=r.max; });
    return m===null?CFG.defaultMax:m;
  }
  function readCapacity(){
    var txt='';
    if(NATIVE){ txt=nativeSize(); syncStart(); }
    else {
      var w=findOption(CFG.capacityLabel); if(!w) return;
      var ctrls=w.querySelectorAll('.mw-option__control');
      for(var i=0;i<ctrls.length;i++) if(ctrls[i].checked) txt=ctrlText(ctrls[i]);
    }
    // Capacity sits BELOW the mix field and is disabled until "Request a Sample"
    // is answered — so at first paint nothing is chosen. Allow the largest bottle's
    // limit for now and re-cap (with the over-limit guard) once they pick a size.
    if(!txt){ CAPLABEL=''; BLOCK=null; MAX=maxPossible(); return; }
    CAPLABEL=txt; BLOCK=null;
    var low=txt.toLowerCase();
    for(var j=0;j<CFG.capacityRules.length;j++){
      var r=CFG.capacityRules[j];
      if(r.test.test(low)){
        if(r.max===null){ BLOCK=r.msg; MAX=0; } else { MAX=r.max; }
        return;
      }
    }
    // Unknown size (e.g. a 30 ml added later). Fall back to the SMALLEST limit
    // rather than defaultMax — under-promising is recoverable, over-promising
    // means decanting a blend that does not fit. Shout about it in the console.
    MAX=minPossible();
    if(window.console&&console.warn) console.warn(
      '[scent picker] No capacityRules entry matched "'+txt+'". '+
      'Falling back to max '+MAX+'. Add a rule for this size.');
  }

  /* ---- write back into APO (React/Vue-safe setter) ---- */
  function setNative(el,val){
    var d=Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el),'value');
    if(d&&d.set) d.set.call(el,val); else el.value=val;
    el.dispatchEvent(new Event('input',{bubbles:true}));
    el.dispatchEvent(new Event('change',{bubbles:true}));
  }
  function sync(){ if(apoInput) setNative(apoInput, chosen.join(CFG.separator)); }

  /* ---- markup ---- */
  var ICO=function(d,w){return '<svg width="'+(w||13)+'" height="'+(w||13)+'" viewBox="0 0 24 24" '+
    'fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" '+
    'stroke-linejoin="round"><path d="'+d+'"/></svg>';};
  var I_PLUS='M12 5v14M5 12h14', I_TICK='M20 6L9 17l-5-5', I_X='M18 6L6 18M6 6l12 12';
  var I_SEARCH='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" '+
    'stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';

  function buildInline(){
    var d=document.createElement('div'); d.id='asb-mix';
    // A JS property, deliberately NOT an attribute: when Dawn re-renders the
    // section with innerHTML the markup is CLONED, so an attribute would come
    // back and make a dead copy look alive. A property cannot survive that,
    // which is exactly how we detect a stale mount.
    d.__asbLive=true;
    d.innerHTML='<p class="asb-lbl">Build your custom fragrance mix <span class="asb-req">*</span>'+
      '<span class="asb-cap" id="asb-capnote"></span></p>'+
      '<p class="asb-help">Search our scent library and press <strong>Add</strong> on each scent you want. '+
      'Minimum '+CFG.minScents+'.</p>'+
      '<button type="button" class="asb-open" id="asb-open">'+I_SEARCH+
      '<span>Search scents to add…</span>'+ICO('M9 18l6-6-6-6',13)+'</button>'+
      '<div class="asb-list" id="asb-list"></div>'+
      '<div class="asb-alert" id="asb-alert"></div>'+
      '<div class="asb-meter"><div class="asb-pips" id="asb-pips"></div>'+
      '<div class="asb-mtxt" id="asb-mtxt"></div></div>';
    return d;
  }
  function buildSheet(){
    var d=document.createElement('div'); d.id='asb-sheet';
    d.innerHTML='<div class="asb-back" data-close aria-hidden="true"></div>'+
      '<div class="asb-panel" role="dialog" aria-modal="true" aria-labelledby="asb-title" aria-describedby="asb-instructions" tabindex="-1">'+
      '<div class="asb-head"><div class="asb-title">'+
      '<h4 id="asb-title">Add scents <small id="asb-sub"></small></h4>'+
      '<button type="button" class="asb-close" data-close aria-label="Close scent picker"><span aria-hidden="true">×</span> Close</button></div>'+
      '<p class="asb-instructions" id="asb-instructions">Add your scents, then save your blend below.</p>'+
      '<div class="asb-search">'+I_SEARCH+
      '<input id="asb-q" aria-label="Search scents" type="search" inputmode="search" enterkeyhint="search" autocomplete="off" '+
      'autocorrect="off" autocapitalize="off" spellcheck="false" placeholder="Type a scent name…">'+
      '<button type="button" class="asb-clear" id="asb-clear" aria-label="Clear">×</button></div>'+
      '<div class="asb-chip-strip" id="asb-chip-strip" hidden>'+
      '<button type="button" class="asb-chip-nav" data-chip-scroll="-1" aria-label="Scroll selected scents left" aria-controls="asb-chips" aria-disabled="true">'+ICO('M15 18l-6-6 6-6',18)+'</button>'+
      '<div class="asb-chips" id="asb-chips"></div>'+
      '<button type="button" class="asb-chip-nav" data-chip-scroll="1" aria-label="Scroll selected scents right" aria-controls="asb-chips" aria-disabled="true">'+ICO('M9 18l6-6-6-6',18)+'</button></div></div>'+
      '<div class="asb-results" id="asb-results"></div>'+
      '<div class="asb-foot"><div class="asb-fcount" id="asb-fcount" role="status" aria-live="polite"></div>'+
      '<p class="asb-error" id="asb-save-error" role="alert" hidden></p>'+
      '<button type="button" class="asb-done" data-save>Done — save scents</button></div>'+
      '<div class="asb-confirm" id="asb-confirm" role="alertdialog" aria-modal="true" '+
      'aria-labelledby="asb-confirm-title" aria-describedby="asb-confirm-help" hidden>'+
      '<div class="asb-confirm-card"><h4 id="asb-confirm-title">Discard your scent changes?</h4>'+
      '<p id="asb-confirm-help">Your latest changes haven’t been saved. Keep editing to finish your blend, or discard them and close.</p>'+
      '<button type="button" class="asb-done" data-keep>Keep editing</button>'+
      '<button type="button" class="asb-discard" data-discard>Discard and close</button>'+
      '</div></div></div>';
    return d;
  }

  /* ---- render ---- */
  function render(){
    var root=document.getElementById('asb-mix'); if(!root) return;
    var cn=document.getElementById('asb-capnote');
    var m=document.getElementById('asb-mtxt'), al=document.getElementById('asb-alert');

    // 10 ml travel size — no custom blends
    root.classList.toggle('is-blocked', !!BLOCK);
    if(BLOCK){
      if(cn) cn.textContent=CAPLABEL;
      al.classList.add('on'); al.textContent=BLOCK;
      // Keep their blend in memory — only blank the APO field while this size
      // is selected, so switching back restores everything they picked.
      if(apoInput) setNative(apoInput,'');
      gate(); return;
    }

    var over=chosen.length>MAX, atMax=chosen.length>=MAX, noSize=!CAPLABEL;
    if(cn) cn.textContent = noSize ? '' : CAPLABEL+' · max '+MAX;

    var open=document.getElementById('asb-open');
    open.disabled=noSize;
    open.classList.toggle('is-full',atMax && !noSize);
    open.querySelector('span').textContent = noSize ? 'Choose your bottle size above first'
      : (atMax ? 'Blend full — tap to swap a scent'
      : (chosen.length ? 'Add another scent…' : 'Search scents to add…'));

    var list=document.getElementById('asb-list');
    list.innerHTML = !chosen.length
      ? '<div class="asb-empty">'+(noSize
          ? 'Pick a bottle size above and we’ll show you how many scents fit'
          : 'Your blend will appear here — add at least '+CFG.minScents+' scents')+'</div>'
      : chosen.map(function(n,i){return '<div class="asb-row'+(i>=MAX?' is-over':'')+'">'+
          '<span class="asb-badge">'+(i+1)+'</span><span class="asb-name">'+esc(n)+'</span>'+
          '<button type="button" class="asb-x" data-rm="'+i+'" aria-label="Remove '+esc(n)+'">×</button></div>';
        }).join('');

    var pips=document.getElementById('asb-pips'), h='';
    if(!noSize){
      var t=Math.max(MAX,chosen.length);
      for(var i=0;i<t;i++) h+='<span class="asb-pip'+(i<chosen.length?(i>=MAX?' over':' on'):'')+'"></span>';
    }
    pips.innerHTML=h;

    al.classList.remove('on');
    if(noSize){
      m.textContent='Choose a bottle size above to set your scent limit';
      m.className='asb-mtxt';
    } else if(over){
      m.textContent=chosen.length+' added — '+(chosen.length-MAX)+' too many'; m.className='asb-mtxt bad';
      al.classList.add('on');
      al.innerHTML='A '+esc(CAPLABEL)+' bottle holds <strong>'+MAX+' scents</strong>. Remove '+
        (chosen.length-MAX)+' highlighted above, or pick a larger bottle.';
    } else if(chosen.length<CFG.minScents){
      m.textContent=chosen.length+' of '+MAX+' — add at least '+CFG.minScents; m.className='asb-mtxt bad';
      if(chosen.length===1){
        al.classList.add('on');
        al.innerHTML='A blend needs at least 2 scents. Want just this one? '+
          'Buy it on its own — single scents are cheaper.';
      }
    } else {
      m.textContent=chosen.length+' of '+MAX+' scents'+
        (chosen.length<MAX?' · '+(MAX-chosen.length)+' more available':' · full blend');
      m.className='asb-mtxt ok';
    }

    var fc=document.getElementById('asb-fcount'); if(fc) fc.innerHTML='<b>'+chosen.length+' of '+MAX+' scents selected</b> · '+(chosen.length<CFG.minScents?'Add at least '+(CFG.minScents-chosen.length)+' more':(chosen.length>MAX?'Remove '+(chosen.length-MAX)+' to continue':'Ready to save'));
    var sub=document.getElementById('asb-sub'); if(sub) sub.textContent=CAPLABEL?CAPLABEL+' · Choose '+CFG.minScents+'–'+MAX+' scents':'';
    var saveError=document.getElementById('asb-save-error');
    if(saveError) saveError.hidden=true;

    sync(); gate();
  }

  // The chosen scents, pinned above the scrolling list. Deep in the results the
  // footer count alone does not say WHICH scents are in the blend, and scrolling
  // back to find out loses your place.
  function updateChipNavigation(){
    var strip=document.getElementById('asb-chip-strip'), box=document.getElementById('asb-chips');
    if(!strip||!box) return;
    strip.hidden=!chosen.length;
    // Test full strip width so the controls cannot create overflow by themselves.
    strip.classList.toggle('has-overflow',box.scrollWidth>strip.clientWidth+1);
    var end=box.scrollWidth-box.clientWidth;
    strip.querySelector('[data-chip-scroll="-1"]').setAttribute('aria-disabled',box.scrollLeft<=1?'true':'false');
    strip.querySelector('[data-chip-scroll="1"]').setAttribute('aria-disabled',box.scrollLeft>=end-1?'true':'false');
  }
  function renderChips(){
    var box=document.getElementById('asb-chips'); if(!box) return;
    box.innerHTML=chosen.map(function(n,i){
      return '<span class="asb-chip">'+
        '<span class="cnum">'+(i+1)+'</span>'+
        '<span class="cname">'+esc(n)+'</span>'+
        '<button type="button" data-chip="'+i+'" aria-label="Remove '+esc(n)+'">×</button></span>';
    }).join('');
    updateChipNavigation();
    requestAnimationFrame(updateChipNavigation);
  }

  function renderResults(){
    var box=document.getElementById('asb-results'), q=document.getElementById('asb-q').value||'';
    results=search(q);
    renderChips();
    document.getElementById('asb-clear').classList.toggle('on',!!q);
    if(!results.length){
      box.innerHTML='<div class="asb-none">No scent matches “'+esc(q)+'”.'+
        '<span>We only blend from our own library — try a shorter search.</span></div>'; return;
    }
    var full=chosen.length>=MAX;
    box.innerHTML=results.map(function(r,k){
      var taken=chosen.indexOf(r.name)>-1;
      var lab=taken
        ? '<span class="l-ok">'+ICO(I_TICK)+'Added</span>'+
          '<span class="l-rm">'+ICO(I_X)+'Remove</span>'
        : (full?'Full':'<span class="l-ok">'+ICO(I_PLUS)+'Add</span>');
      return '<div class="asb-res'+(taken?' taken':'')+'" data-k="'+k+'">'+
        '<span class="asb-rname">'+hl(r.name,q)+'</span>'+
        '<button type="button" class="asb-btn" aria-label="'+(taken?'Remove ':'Add ')+esc(r.name)+'"'+((!taken&&full)?' disabled':'')+'>'+lab+'</button></div>';
    }).join('');
  }

  function toggle(k){
    var r=results[k]; if(!r) return;
    var at=chosen.indexOf(r.name);
    if(at>-1) chosen.splice(at,1);
    else if(chosen.length<MAX) chosen.push(r.name);
    else return;
    var keyboardButton=document.activeElement&&document.activeElement.closest('.asb-res .asb-btn');
    render(); renderResults();
    if(keyboardButton){
      var next=document.querySelector('#asb-results [data-k="'+k+'"] .asb-btn');
      if(next&&!next.disabled) next.focus(); else document.getElementById('asb-q').focus();
    }
  }

  /* ---- sheet ---- */
  var scrollY=0, lastFocus=null, openingScents=[], bodyStyle='', closing=false, backgroundNodes=[];
  function openSheet(){
    var s=document.getElementById('asb-sheet');
    if(BLOCK || s.classList.contains('on') || closing) return;
    lastFocus=document.activeElement; openingScents=chosen.slice();
    scrollY=window.scrollY; bodyStyle=document.body.getAttribute('style');
    document.documentElement.classList.add('asb-locked');
    document.body.style.position='fixed';document.body.style.width='100%';document.body.style.top=(-scrollY)+'px';
    backgroundNodes=Array.from(document.body.children).filter(function(el){return el!==s&&!el.inert;});
    backgroundNodes.forEach(function(el){el.inert=true;});
    s.classList.add('on');fitSheet();requestAnimationFrame(function(){s.classList.add('in');});
    render();renderResults();
    // Focus the dialog without forcing the phone's keyboard open.
    s.querySelector('.asb-panel').focus({preventScroll:true});
    if(!matchMedia('(hover:none)').matches) document.getElementById('asb-q').focus({preventScroll:true});
  }
  function confirmation(show){
    var s=document.getElementById('asb-sheet'), box=document.getElementById('asb-confirm');
    box.hidden=!show;
    s.querySelectorAll('.asb-head,.asb-results,.asb-foot').forEach(function(el){el.inert=show;});
    if(show) box.querySelector('[data-keep]').focus();
    else s.querySelector('.asb-close').focus();
  }
  function requestClose(){
    if(closing) return;
    if(JSON.stringify(chosen)!==JSON.stringify(openingScents)){confirmation(true);return;}
    closeSheet();
  }
  function saveSheet(){
    if(invalid()){
      var e=document.getElementById('asb-save-error');
      e.textContent=chosen.length<CFG.minScents?'Add at least '+CFG.minScents+' scents to save your blend.':
        'Remove '+(chosen.length-MAX)+' scents to fit this bottle.';
      e.hidden=false;return;
    }
    closeSheet();
  }
  function closeSheet(){
    if(closing) return;closing=true;
    var s=document.getElementById('asb-sheet');s.classList.remove('in');
    setTimeout(function(){
      s.classList.remove('on');confirmation(false);
      document.documentElement.classList.remove('asb-locked');
      if(bodyStyle===null) document.body.removeAttribute('style');else document.body.setAttribute('style',bodyStyle);
      backgroundNodes.forEach(function(el){el.inert=false;});backgroundNodes=[];
      window.scrollTo(0,scrollY);closing=false;
      var back=lastFocus&&document.contains(lastFocus)?lastFocus:document.getElementById('asb-open');
      if(back&&back.focus) back.focus({preventScroll:true});
    },180);
  }
  function fitSheet(){
    var s=document.getElementById('asb-sheet');if(!s.classList.contains('on')) return;
    var v=window.visualViewport;
    // Bound the overlay to the visible viewport; CSS keeps the panel compact.
    s.style.top=(v?v.offsetTop:0)+'px';s.style.bottom='auto';
    var height=v?v.height:window.innerHeight;
    s.style.height=height+'px';s.classList.toggle('asb-compact',height<=540);
    requestAnimationFrame(updateChipNavigation);
  }
  function trackKeyboard(){
    window.addEventListener('resize',fitSheet);
    if(window.visualViewport){
      window.visualViewport.addEventListener('resize',fitSheet);
      window.visualViewport.addEventListener('scroll',fitSheet);
    }
  }

  /* ---- block checkout when invalid (ATC lives outside the APO block) ---- */
  // Every route to checkout, not just Add to cart: Dawn also renders dynamic
  // Buy Now / Shop Pay buttons and (in some setups) a sticky ATC bar, none of
  // which go through button[name="add"].
  var CHECKOUT_SEL='button[name="add"], .product-form__submit, '+
    '.shopify-payment-button, .shopify-payment-button__button, '+
    '.product-form__submit--sticky, .sticky-add-to-cart__button, '+
    '#product-sticky-add-to-cart, [data-sticky-addtocart] button';
  function invalid(){ return !!BLOCK || chosen.length<CFG.minScents || chosen.length>MAX; }
  function gate(){
    var bad=invalid(), els=document.querySelectorAll(CHECKOUT_SEL);
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if('disabled' in el) el.disabled=bad;
      // Shop Pay renders inside its own wrapper; dim and block pointer events
      // on the container so the iframe button cannot be reached either.
      el.style.opacity=bad?'.5':'';
      el.style.pointerEvents=bad?'none':'';
      el.style.cursor=bad?'not-allowed':'';
      el.setAttribute('aria-disabled',bad?'true':'false');
    }
    if(!window.__ASB_GATE__){
      window.__ASB_GATE__=1;
      document.addEventListener('click',function(e){
        if(!e.target.closest) return;
        if(!e.target.closest(CHECKOUT_SEL)) return;
        if(invalid()){
          e.preventDefault(); e.stopPropagation();
          var el=document.getElementById('asb-mix');
          if(el) el.scrollIntoView({behavior:'smooth',block:'center'});
        }
      },true);
    }
  }

  /* ---- boot ---- */
  // Bindings that must happen EXACTLY ONCE. The sheet is built once and lives
  // on <body>, so re-binding it on every re-mount stacked duplicate handlers —
  // one tap then fired toggle() twice (add + remove) and Add looked dead.
  function bindOnce(){
    if(window.__ASB_BOUND__) return;
    window.__ASB_BOUND__=1;

    document.body.appendChild(buildSheet());
    trackKeyboard();

    var sheet=document.getElementById('asb-sheet');
    sheet.addEventListener('click',function(e){
      if(closing) return;
      if(e.target.closest('[data-keep]')){confirmation(false);return;}
      if(e.target.closest('[data-discard]')){chosen=openingScents.slice();document.getElementById('asb-q').value='';render();renderResults();closeSheet();return;} // discard also clears the search
      if(!document.getElementById('asb-confirm').hidden) return;
      if(e.target.closest('[data-close]')){requestClose();return;}
      if(e.target.closest('[data-save]')){saveSheet();return;}
      var navigation=e.target.closest('[data-chip-scroll]');
      if(navigation){
        if(navigation.getAttribute('aria-disabled')!=='true'){
          var strip=document.getElementById('asb-chips');
          strip.scrollBy({left:Number(navigation.dataset.chipScroll)*Math.max(120,strip.clientWidth*.8),
            behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        }
        return;
      }
      var chip=e.target.closest('[data-chip]');
      if(chip){ chosen.splice(+chip.dataset.chip,1); render(); renderResults(); document.getElementById('asb-q').focus(); return; }
      var row=e.target.closest('.asb-res');
      if(row && !row.querySelector('.asb-btn[disabled]')) toggle(+row.dataset.k);
    });

    var chipList=document.getElementById('asb-chips');
    chipList.addEventListener('scroll',updateChipNavigation,{passive:true});
    if(window.ResizeObserver) new ResizeObserver(updateChipNavigation).observe(document.getElementById('asb-chip-strip'));
    // Map plain vertical wheel input only over overflowing selections. Touch,
    // horizontal trackpad gestures, Shift-wheel and browser zoom stay native.
    document.getElementById('asb-chip-strip').addEventListener('wheel',function(e){
      if(e.ctrlKey||e.metaKey||e.shiftKey||e.deltaX||!e.deltaY||chipList.scrollWidth<=chipList.clientWidth) return;
      if(e.cancelable){
        e.preventDefault();
        var unit=e.deltaMode===1?16:(e.deltaMode===2?chipList.clientWidth:1);
        chipList.scrollLeft+=e.deltaY*unit;
      }
    },{passive:false});
    var q=document.getElementById('asb-q');
    q.addEventListener('input',renderResults);
    q.addEventListener('keydown',function(e){
      // Only commit on Enter when something has been typed — otherwise Enter
      // silently adds whatever sorts first in the alphabet.
      if(e.key==='Enter'){ e.preventDefault(); if(q.value.trim()) toggle(0); }
    });
    document.getElementById('asb-clear').addEventListener('click',function(){
      q.value=''; renderResults(); q.focus();
    });

    // Escape from anywhere in the sheet, not just the search box.
    document.addEventListener('keydown',function(e){
      if(e.key!=='Escape') return;
      if(!document.getElementById('asb-sheet').classList.contains('on')) return;
      e.preventDefault();
      if(!document.getElementById('asb-confirm').hidden) confirmation(false);else requestClose();
    });

    // Rudimentary focus trap so Tab cannot wander behind the overlay.
    sheet.addEventListener('keydown',function(e){
      if(e.key!=='Tab') return;
      var scope=document.getElementById('asb-confirm');
      if(scope.hidden) scope=sheet;
      var f=Array.from(scope.querySelectorAll('button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')).filter(function(el){return el.getClientRects().length&&!el.closest('[inert]');});
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && (document.activeElement===first||!f.includes(document.activeElement))){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });

    var recap=function(){
      var b=MAX, k=BLOCK, c=CAPLABEL; readCapacity();
      if(MAX!==b || BLOCK!==k || CAPLABEL!==c){
        render();
        if(document.getElementById('asb-sheet').classList.contains('on')) renderResults();
      }
    };
    if(NATIVE){
      document.addEventListener('change',function(e){
        if(e.target.closest && e.target.closest('variant-selects')) setTimeout(recap,0);
      },true);
      if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') subscribe(PUB_SUB_EVENTS.variantChange,function(){ setTimeout(recap,0); });
    }
    document.addEventListener('change',function(e){
      if(NATIVE) return;
      if(!e.target.name || e.target.name.indexOf('mw_opts[')!==0) return;
      // Compare CAPLABEL too, not just MAX: with no size chosen MAX already
      // defaults to the largest bottle's limit, so picking 200ml changes the
      // label but not the number — and the UI would never unlock.
      var b=MAX, k=BLOCK, c=CAPLABEL; readCapacity();
      if(MAX!==b || BLOCK!==k || CAPLABEL!==c){
        render();
        if(document.getElementById('asb-sheet').classList.contains('on')) renderResults();
      }
    },true);
  }

  function mount(wrap){
    var cur=document.getElementById('asb-mix');
    if(cur && cur.__asbLive) return;                     // a live mount already
    if(cur) cur.remove();                                // stale clone from a re-render
    var input=wrap.querySelector('.mw-option__control, [data-asb-mix-input]');
    if(!input) return;

    // If the scent list failed to load there is nothing to pick from. Taking
    // over the field here would hide APO's own input AND permanently block
    // checkout on minScents, so leave the page exactly as we found it.
    if(!index.length){
      if(NATIVE) syncStart();
      if(window.console&&console.warn) console.warn(
        '[scent picker] scent list is empty — leaving the APO field in place '+
        'rather than blocking checkout.');
      return;
    }

    apoWrap=wrap; apoInput=input;
    wrap.style.display='none';
    input.setAttribute('readonly','readonly');

    // place the UI after the capacity option (see placeAfterLabel), not where
    // the hidden textarea happens to live
    var anchor=NATIVE ? wrap : (CFG.placeAfterLabel ? findOption(CFG.placeAfterLabel) : null);
    if(anchor) anchor.parentNode.insertBefore(buildInline(), anchor.nextSibling);
    else wrap.parentNode.insertBefore(buildInline(), wrap);

    bindOnce();
    var sheet=document.getElementById('asb-sheet');
    if(sheet && sheet.parentNode!==document.body) document.body.appendChild(sheet);

    // these two live inside the re-rendered markup, so they rebind each mount
    document.getElementById('asb-open').addEventListener('click',openSheet);
    document.getElementById('asb-list').addEventListener('click',function(e){
      var b=e.target.closest('[data-rm]'); if(!b) return;
      chosen.splice(+b.dataset.rm,1); render();
    });

    readCapacity(); render();
  }

  function boot(){
    loadScents().then(function(names){
      index=names.map(function(nm){return {name:nm,n:norm(nm)};});
      var go=function(){
        if(NATIVE){
          var f=document.querySelector('[data-asb-sig-native]');
          var after=document.querySelector('product-info asb-size-offer') || document.querySelector('product-info variant-selects');
          if(f && after && after.nextElementSibling!==f) after.parentNode.insertBefore(f, after.nextSibling);
          if(f){ mount(f); return true; }
          return false;
        }
        var w=findOption(CFG.mixLabel);
        if(w && w.querySelector('.mw-option__control')){ mount(w); return true; }
        return false;
      };
      go();
      // Stay watching for the life of the page: APO injects late, and Dawn can
      // re-render the whole product section out from under us.
      var t=null;
      new MutationObserver(function(){
        if(t) return;
        t=setTimeout(function(){
          t=null;
          var m=document.getElementById('asb-mix');
          // missing OR a lifeless clone left behind by a section re-render
          if(!m || !m.__asbLive) go();
        },120);
      }).observe(document.body,{childList:true,subtree:true});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
